import { API_ENDPOINTS } from "../../src/constants";
import { apiClient } from './apiClient';

export interface SendMessageInput {
  chatbotId: string;
  clientId?: string
  tenantId: string;
  userId: string;
  message: string;
  conversationId?: string;
  viewType?: string;
}

export async function sendMessageApi(data: SendMessageInput, authenticate: boolean = false) {
  const result = await apiClient.post(API_ENDPOINTS.CHAT.SEND_MESSAGE, data, {
    authenticate,
    timeoutMs: 120000,  // 120 seconds
  });
  return result as any;
}

// streaming variant
export async function sendMessageStreamApi(
  data: SendMessageInput,
  authenticate: boolean = false
) {
  const { response } = await apiClient.postStream(API_ENDPOINTS.CHAT.SEND_MESSAGE, data, {
    authenticate,
    timeoutMs: 120000,
  });
  return response; // native fetch Response
}
